// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__G8B76","waiting_button":"styles_waiting_button__SWniV"};